import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { RouterProvider } from 'react-router';
import { router } from '@/app/router';
import { AuthProvider } from '@/lib/auth/auth-provider';
import { initAppCheck } from '@/lib/app-check';
import { initAnalytics } from '@/lib/firebase';
import { AntdProvider } from '@/lib/ui/antd-provider';
import '@/styles/index.css';

initAppCheck();
createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <AntdProvider>
      <AuthProvider>
        <RouterProvider router={router} />
      </AuthProvider>
    </AntdProvider>
  </StrictMode>,
);
void initAnalytics();
